import { createContext, useState, useEffect, useContext } from "react";
import useLocation from "wouter/use-location";

const ScrollContext = createContext({
  fadeHeader: null,
  dropdownHeader: null,
});

export const useScrollCtx = () => {
  const { fadeHeader, dropdownHeader } = useContext(ScrollContext);

  return { fadeHeader, dropdownHeader };
};

export const ScrollContextProvider = ({ children }) => {
  const [location] = useLocation();
  const [fadeHeader, setFadeHeader] = useState(false);
  const [dropdownHeader, setDropdownHeader] = useState(true);

  const scrollHandler = () => {
    // if (window.scrollY > 250 && !fadeHeader && location === "/acerca") {
    // 	setFadeHeader(true);
    // } else if (window.scrollY === 0 && location === "/acerca") {
    // 	setFadeHeader(false);
    // } else if ( window.scrollY > 117 && !dropdownHeader && location === "/industry/equipo-pesado"	) {
    // 	setDropdownHeader(true);
    // } else if (window.scrollY < 117 && location === "/industry/equipo-pesado") {
    // 	setDropdownHeader(false);
    // }
    if (location === "/") {
			if (window.scrollY > 700 && location === "/") {
				setDropdownHeader(true);
				setFadeHeader(true);
			} else {
				setDropdownHeader(false);
				setFadeHeader(false);
			}
    } else {
			if (window.scrollY > 250 && !fadeHeader) {
				setFadeHeader(true);
			} else if (window.scrollY === 0) {
				setFadeHeader(false);
			} else if (window.scrollY > 117 && !dropdownHeader) {
				setDropdownHeader(true);
			} else if (window.scrollY < 117) {
				setDropdownHeader(false);
			}
		}
  	};

  useEffect(() => {
    // if (location === "/acerca" || location === "/industry/equipo-pesado" || location === "/carreras" ) {
    // 	window.addEventListener("scroll", scrollHandler);
    // }
    window.addEventListener("scroll", scrollHandler);

    return () => {
      if (fadeHeader) {
        setFadeHeader(false);
      }
      window.removeEventListener("scroll", scrollHandler);
    };

    // eslint-disable-next-line
  }, [location, dropdownHeader, fadeHeader]);

  const context = {
    fadeHeader,
    dropdownHeader,
  };

  return (
    <ScrollContext.Provider value={context}>{children}</ScrollContext.Provider>
  );
};

export default ScrollContext;
